import React, { useState } from 'react';
import './App.css';
import MainNavigation from './components/layout/MainNavigation';
import { linkData } from './components/ui/linkData';
import { clientLinks } from './components/ui/clientLinks';

const tabs = [
  { name: 'Personal Sites', tabNum: 2 },
  { name: 'Ecomm Sites', tabNum: 1 },
  { name: 'API Docs', tabNum: 0 }
  
];

function App() {
  // tabbed formatting
  const [activeTab, setActiveTab] = useState(0);

  return (
    <>
    <MainNavigation />
    <div className='main'>
      <div className='full-width'>

        <div className="tabs">
          {tabs.map((tab, index) => (
            <button
              key={index}
              className={index === activeTab ? 'tab active' : 'tab'}
              onClick={() => setActiveTab(index)}
            >
              {tab.name}
            </button>
          ))}
        </div>

        {tabs[activeTab].tabNum === 0 &&
          <div class="tab">
            <h2>API Documentation</h2>
             <p>I've decided to marry my decade of experience as a web developer with the previous 15 years of experience as a technical writer.  In theory, my dual-background experience should make me a good resource for documenting code, such as <strong>Application Programming Interfaces</strong> (APIs).</p>
             <p>(This area is very much "under development" since this is a new endeavor.)</p>
            <h3>Homebrewed HTML doc system</h3>
             <p>This is a "from scratch" pass at documenting the <a href="https://jsonplaceholder.typicode.com/" target="new">JSON Placeholder API</a> - a simple APi that mocks the bility to fetch, add, modify, or delete simple JSON-formatted user records.</p>
             <p>This small help system organizes the topics by endpoint and http method, giving a description, code sample(s), and possible results.</p>
             <a href="../APIdocs/homebrew_jsonPlaceholder/index.html" target="new">My HTML help for the JSONPlaceholder API</a>
            <h3>OpenAPI-compliant YAML files</h3>
              <p>These links allow you to download OpenAPI-compliant YAML files which can be imported into the free online <a href="https://editor.swagger.io/" target="new">Swagger editor.</a></p>
             <p>Click the link to download the file, then go to the <a href="https://editor.swagger.io/" target="new">online editor</a> and <strong>import</strong> it there.</p>
            <ul>
              <li><a href="./static/JSONPlaceholderAPI.yaml">JSON Placeholder API</a> - a simple APi that mocks the bility to fetch, add, modify, or delete simple JSON-formatted user records. <br></br>
              Alternatively, you can view a bare-bones standalone web version of the docs <a href="../APIdocs/OpenApiJSONPlaceholder/index.html" target="new">here</a>.  Note that this version has minimal formatting and does not include the ability to test out the endpoints within the docs.</li>
              <li><a href="./static/Sunrise-Sunset.yaml">Sunrise-Sunset API</a> - A very simple single-function API to retrieve the sunrise & sunset time.  Only supports one method (GET) but many possible parameters.</li>
            </ul>
          </div>
        }
        {tabs[activeTab].tabNum === 1 &&
          <div class="tab">
            <h2>Client Sites</h2>
            <p>These are a few of the sites that I worked on for previous employers.  Since I don't own the code bases I cannot host anything, but you can see the types of work that I've done between 2013 and 2023.</p>
            <ul>
              {clientLinks.map((data) => 
                <li>
                  <a href={data.url} target='none'>{data.name}</a>
                </li>
              )}
            </ul>
          </div>}

          {tabs[activeTab].tabNum === 2 &&
            <h2>Personal Sites</h2>}
      </div>
      
      {linkData.map((data) => 
        tabs[activeTab].tabNum === 2 &&
          <div className='tile'>
            <div className='tile-content'>
              <a href={data.url} target='none'>
                <div className='tileimg'>
                  <img src={data.image} alt='thumbnail of a website'/>
                </div>
                <h2>{data.title}</h2>
                <h3>{data.date}</h3>
                <p>{data.description}</p>
              </a>
            </div>
          </div>
      )}
    </div>
    <div className='footer'> 
      <a href='https://mattwdeacon.com/portfolio/portfolio_white.html'>Click here for my (very) old legacy portfolio site</a>
    </div>
    </>
  )};

export default App;
